import {createTheme} from "@mui/material/styles";

export const appTheme = createTheme({
    typography: {
        fontFamily: `"Space Grotesk", sans-serif`,
        h1: {
            fontSize: "1.875rem", //30px
            lineHeight: 1.27,
            fontWeight: 500,
            textOverflow: "ellipsis",
        },
        h2: {
            fontSize: "1.25rem",
            fontWeight: 500,
            lineHeight: 1.3,
        },
        h3: {
            fontSize: "1.125rem",
            fontWeight: 500,
            lineHeight: 1.35,
        },
        h4: {
            fontSize: "1rem", //16px
            fontWeight: 400,
            lineHeight: 1.35,
            textTransform: "uppercase",
        },
        h5: {
            fontSize: "0.875rem", //14px
            fontWeight: 500,
            lineHeight: "normal",
            textTransform: "uppercase",
        },
        h6: {
            fontSize: "0.75rem", //12px
            fontWeight: 500,
            lineHeight: "normal",
            color: "#737990",
            textTransform: "uppercase",
        },
    },
    palette: {
        mode: "light",
        primary: {
            main: "#404db8",
            dark: "#5460c3",
        },
        secondary: {
            main: "#E9EBF1",
            contrastText: "#303A8C",
        },
        error: {
            main: "#d32f2f",
        },
        impersonation: {
            main: "#9c27b0",
            light: "#ba68c8",
            dark: "#7b1fa2",
            contrastText: "#ffffff",
        },
        dark: {
            main: "#171e39",
            contrastText: "#ffffff",
        },
        development: {
            main: "#266102",
            contrastText: "#ffffff",
        },
        staging: {
            main: "#860101",
            contrastText: "#ffffff",
        },
        sandbox: {
            main: "#ab7501",
            contrastText: "#ffffff",
        },
    },
    components: {
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    fontWeight: "bold",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontSize: "1rem",
                    letterSpacing: ".04em",
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    "& .MuiFilledInput-root": {
                        background: "#E9EBF1",
                        borderRadius: "4px",
                    },
                    "& .MuiFilledInput-input": {
                        height: "20px !important",
                        minHeight: "20px !important",
                        padding: "6px 9px !important",
                        disabledUnderline: true,
                    },
                },
            },
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    "& .MuiFilledInput-input": {
                        background: "#E9EBF1",
                        height: "20px !important",
                        minHeight: "20px !important",
                        padding: "6px 9px !important",
                        disabledUnderline: true,
                    },
                    "& .MuiInputBase-inputMultiline": {
                        height: "100px !important",
                    },
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    "& .MuiFilledInput-root": {
                        background: "#E9EBF1",
                        borderRadius: "4px",
                    },
                    "& .MuiFilledInput-input": {
                        height: "20px !important",
                        minHeight: "20px !important",
                        padding: "6px 9px !important",
                        disabledUnderline: true,
                    },
                },
            },
        },
    },
});
